(function (ng) {
    //component definition for the main initiate return form
    ng.module('evo.returns.initiate.components').component('createRequestForm', {
        templateUrl: ['TEMPLATES_BASE',
            function (TEMPLATES_BASE) {
                return TEMPLATES_BASE + 'returns/initiate/components/createRequestForm';
            }],
        bindings: {
            createRequest: '<'
        },
        controller: ['$state',
            function ($state) {
                var ctrl = this,
                    itemsBeingReturned = [];

                ctrl.showCommentBox = false;
                ctrl.warrantyMessaging = false;
                ctrl.showPrepaidLabelOption = false;
                ctrl.itemsBeingReturnedCount = 0;
                ctrl.labelPrice = 0;

                //submit the RA to the parent component if it's valid
                ctrl.submit = function (form) {
                    if (!form || !form.$valid) {
                        return;
                    }

                    $state.go('initiate.confirmRequestPage');
                };

                //event handler for when the label type changes
                //assigns the correct label price to the request
                ctrl.updateLabelType = function () {
                    ctrl.createRequest.LabelPrice = ctrl.createRequest.LabelType == 1 ? ctrl.labelPrice : 0;
                };

                //method to keep track of the items being returned
                ctrl.updateReturnReason = function (item, returnReason) {
                    item.ReturnReason = returnReason;

                    updateReturningItemsAndLabelPrice();
                };

                //helper method that updates the label price based on the items that are being returned
                function updateReturningItemsAndLabelPrice() {
                    ctrl.showCommentBox = false;
                    ctrl.warrantyMessaging = false;

                    itemsBeingReturned = ctrl.createRequest.Items.filter(function (item) {
                        if (item.ReturnReason) {
                            if (item.ReturnReason.indexOf('(comment optional)') > 0) {
                                ctrl.showCommentBox = true;
                            }

                            if (item.ReturnReason.indexOf('(broken)') > 0) {
                                ctrl.warrantyMessaging = true;
                            }
                            return true;
                        }
                        return false;
                    });

                    ctrl.itemsBeingReturnedCount = itemsBeingReturned.length;
                    ctrl.labelPrice = ctrl.itemsBeingReturnedCount
                        ? itemsBeingReturned.reduce(function (maxLabelPrice, item) { return Math.max(maxLabelPrice, isNaN(parseInt(item.ReturnPrice, 10)) ? 7 : item.ReturnPrice); }, 0)
                        : 7;

                    // if the total refund amount is less than the label price don't show the label option
                    let refundAmount = ctrl.itemsBeingReturnedCount
                        ? itemsBeingReturned.reduce((sum, item) => item.Subtotal + sum, 0) : 0;
                    ctrl.showPrepaidLabelOption = refundAmount > ctrl.labelPrice;
                }

                ctrl.$onInit = updateReturningItemsAndLabelPrice;
            }]
    });
})(angular);